import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import PageTitle from "../components/PageTitle";
import Loader from "examples/Loader";
import React, { useEffect, useState } from "react";
import Tabs from "../components/Tabs";
import Blogs from "./components/blogs";
import Jobs from "./components/jobs";
import News from "./components/news";
import Events from "./components/events";
import Reviews from "./components/reviews";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import { useKnowledgeBase } from "context/knowledgebaseContext";
import ClaimRequest from "../Accounts/components/Tabs/ClaimRequest";
import "./submissionsCompact.css";

const Submissions = () => {
  const [loader, setloader] = useState(true);
  const [List, setList] = useState([]);
  const AppService = useAppServices();
  const { knowledgeBase, loading } = useKnowledgeBase();
  const [claimBusinessData, setClaimBusinessData] = useState([]);
  const [agency] = useAgencyInfo();
  const onLoad = async () => {
    const { response } = await AppService.agency.GetSubmissions({
      query: `agency_id=${agency._id}`,
    });
    const { response: reviewsResponse } = await AppService.reviews.get({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      const data = response?.data || {};
      data.reviews = reviewsResponse?.data || [];
      setList(data);
      setloader(false);
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  const getClaimeBusiness = async () => {
    const agencyId = agency?._id;
    const { response } = await AppService.claim_business.Get({
      query: `agency_id=${agencyId}`,
    });
    if (response) {
      setClaimBusinessData(response?.data ?? []);
    }
  };

  useEffect(() => {
    getClaimeBusiness();
  }, []);

  return loader ? (
    <Loader />
  ) : (
    <>
      <style>
        {`
       .kb-help-text-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
}

.kb-help-text-btn:hover {
  background: #eef2ff;
  color: #2f80ed;
  border-color: #c7d2fe;
}

`}
      </style>
      <PageLayout>
        <SoftBox alignItems="center" className="sd-submissions sd-page">
          <div
            className="sd-page__header d-flex w-100 align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <PageTitle helpUrl={!loading && knowledgeBase?.submission}>
              Submissions
            </PageTitle>
          </div>
          <Tabs
            tabsData={[
              {
                label: `Claim Requests (${
                  claimBusinessData?.filter(
                    (item) => item?.request_type === "claim" && item.status === "pending"
                  ).length || 0
                })`,
                content: <ClaimRequest type="claim" onLoad={getClaimeBusiness} />,
              },
              {
                label: `New Business Requests (${
                  claimBusinessData?.filter(
                    (item) => item?.request_type === "new" && item.status === "pending"
                  ).length
                })`,
                content: <ClaimRequest type="new" onLoad={getClaimeBusiness} />,
              },
              {
                label: `Blogs (${List?.blogs?.length})`,
                content: <Blogs data={List?.blogs} onLoad={onLoad} agency={agency} />,
              },
              {
                label: `Jobs (${List?.jobs?.length})`,
                content: <Jobs data={List?.jobs} onLoad={onLoad} agency={agency} />,
              },
              {
                label: `News (${List?.news?.length})`,
                content: <News data={List?.news} onLoad={onLoad} agency={agency} />,
              },
              {
                label: `Events (${List?.events?.length})`,
                content: <Events data={List?.events} onLoad={onLoad} agency={agency} />,
              },
              {
                label: `Review Management (${List?.reviews?.length})`,
                content: <Reviews data={List?.reviews} onLoad={onLoad} agency={agency} />,
              },
            ]}
          />
        </SoftBox>
      </PageLayout>
    </>
  );
};
export default Submissions;
